import {
  Component,
  Input,
  ElementRef,
  Renderer2,
  AfterViewInit,
  OnDestroy,
  HostListener,
  SimpleChanges,
  OnChanges
} from '@angular/core';
import { Card, CardsArray } from '../../../model/cards';
import {NgForOf, NgIf} from '@angular/common';
import { MenuCardElComponent } from '../menu-card-el/menu-card-el.component';
import {TextsComponent} from '../texts/texts.component';
import {LocationDto} from '../../../model/continent';
import {TitleBackgroundComponent} from '../title-background/title-background.component';
import {Router} from '@angular/router';
import {MenuService} from '../../../services/menu-services';
import {ServicesService} from '../../../services/services-service';
import {ServiceElComponent} from '../../pages/services-page/elements/slider-horizontal/service-el/service-el.component';
import {Services, ServicesArray} from '../../../model/services';
import {FeedbackComponent} from '../feedback/feedback.component';
import {FeedbackService} from '../../../services/feedback-service';
import {FeedbackPageComponent} from '../../pages/feedback-page/feedback-page.component';
import {scrollUp} from '../../../functions/scroll-up';

@Component({
  selector: 'app-menu-vertical-slider',
  imports: [
    NgForOf,
    MenuCardElComponent,
    TextsComponent,
    TitleBackgroundComponent,
    NgIf,
    ServiceElComponent
  ],
  templateUrl: './menu-vertical-slider.component.html',
  styleUrl: './menu-vertical-slider.component.scss'
})
export class MenuVerticalSliderComponent implements AfterViewInit, OnDestroy, OnChanges {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private router: Router,
    protected menuService: MenuService,
    protected service: ServicesService,
    public feedValue: FeedbackService) {}

  @Input() cards: Card[] = CardsArray;
  @Input() locations: LocationDto[] = [];
  @Input() menuIdx: number = 0;

  wheelListener: (() => void) | null = null;
  scrollListener: (() => void) | null = null;
  touchpadListener: (() => void) | null = null;
  activeCardIndex: number = 0;
  isScrolling: boolean = false;
  activeIdx: number | null = null;
  lastScrollTime: number = 0;
  scrollTimeout: any = null;
  mockFeedback: Services = new Services({
    img: '',
    title: [],
  });

  ngAfterViewInit() {
    this.setupVerticalSnap();
    this.setupWheelEvents();
    this.setupTouchpadEvents();
    this.setupScrollDetection();
    this.updateActiveCardStyles();
  }

  ngOnDestroy() {
    if (this.wheelListener) {
      this.wheelListener();
    }
    if (this.scrollListener) {
      this.scrollListener();
    }
    if (this.touchpadListener) {
      this.touchpadListener();
    }
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['cards'] && !changes['cards'].firstChange) {
      this.resetScroll();
    }
  }

  resetScroll() {
    const container = this.el.nativeElement.querySelector('.vertical-slider-content');
    if (container) {
      container.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      this.activeCardIndex = 0;
      this.updateActiveCardStyles();
    }
  }

  openPage(idx: number) {
    this.activeIdx = idx;
    let url: string = '';
    switch (this.menuIdx) {
      case 0: break;
      case 1:
        url = '/destinations/' + this.locations[this.activeIdx].url
        break;
      case 2:
        url = '/services/'
        this.service.setActiveService(idx);
        break;
      case 3:
        url = '/adventures/' + this.locations[this.activeIdx].url
        break;
      case 4:
        url = '/feedback/';
        this.feedValue.setFeedbackValue([{text: ['Другое', 'Other']}]);
        break;
      default: break;
    }
    setTimeout(() => {
      scrollUp();
      this.router.navigate( [ url ] ).then(r => r);
      this.activeIdx = null;
      this.menuService.setActive();
    }, 500)
  }

  setupVerticalSnap() {
    const container = this.el.nativeElement.querySelector('.vertical-slider-content');
    this.renderer.setStyle(container, 'scroll-snap-type', 'y mandatory');
    this.renderer.setStyle(container, 'scroll-behavior', 'smooth');
  }

  setupWheelEvents() {
    const container = this.el.nativeElement.querySelector('.vertical-slider-content');
    this.wheelListener = this.renderer.listen(container, 'wheel', (event: WheelEvent) => {
      if (this.isScrolling) {
        event.preventDefault();
        return;
      }
      if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
        return;
      }
      event.preventDefault();
      this.handleScrollEvent(event.deltaY > 0);
    }, { passive: false });
  }

  setupTouchpadEvents() {
    const container = this.el.nativeElement.querySelector('.vertical-slider-content');
    this.touchpadListener = this.renderer.listen(container, 'scroll', (event: Event) => {
      if (this.isScrolling) {
        event.preventDefault();
        container.scrollTop = this.activeCardIndex * (container.clientHeight * 0.7);
        return;
      }
      const currentScroll = container.scrollTop;
      const containerHeight = container.clientHeight;
      const cardHeight = containerHeight * 0.7;
      const expectedScroll = this.activeCardIndex * cardHeight;
      if (Math.abs(currentScroll - expectedScroll) > 10) {
        container.scrollTop = expectedScroll;
      }
    });
  }

  handleScrollEvent(isScrollingDown: boolean) {
    if (this.isScrolling) return;
    const container = this.el.nativeElement.querySelector('.vertical-slider-content');
    const containerHeight = container.clientHeight;
    const cardHeight = containerHeight * 0.7;
    let targetIndex: number;
    if (isScrollingDown) {
      targetIndex = Math.min(this.activeCardIndex + 1, this.cards.length - 1);
    } else {
      targetIndex = Math.max(this.activeCardIndex - 1, 0);
    }
    if (targetIndex === this.activeCardIndex) return;
    this.isScrolling = true;
    this.scrollToCard(targetIndex);
    setTimeout(() => {
      this.isScrolling = false;
    }, 1000);
  }

  setupScrollDetection() {
    const container = this.el.nativeElement.querySelector('.vertical-slider-content');
    this.scrollListener = this.renderer.listen(container, 'scroll', () => {
      if (this.isScrolling) return;
      this.detectActiveCard();
    });
  }

  detectActiveCard() {
    const container = this.el.nativeElement.querySelector('.vertical-slider-content');
    const containerHeight = container.clientHeight;
    const scrollPosition = container.scrollTop;
    const cardHeight = containerHeight * 0.7;
    const newActiveIndex = Math.floor((scrollPosition + cardHeight / 2) / cardHeight);
    if (newActiveIndex !== this.activeCardIndex && newActiveIndex >= 0 && newActiveIndex < this.cards.length) {
      this.activeCardIndex = newActiveIndex;
      this.updateActiveCardStyles();
    }
  }

  updateActiveCardStyles() {
    const imgContainers = this.el.nativeElement.querySelectorAll('.vertical-slider-card-img');
    imgContainers.forEach((imgContainer: HTMLElement, index: number) => {
      if (index === this.activeCardIndex) {
        this.renderer.setStyle(imgContainer, 'transform', 'scale(0.9)');
      } else {
        this.renderer.setStyle(imgContainer, 'transform', 'scale(0.7)');
      }
      this.renderer.setStyle(imgContainer, 'transition', 'transform 0.3s ease');
    });
  }

  scrollToCard(index: number) {
    const container = this.el.nativeElement.querySelector('.vertical-slider-content');
    const containerHeight = container.clientHeight;
    const targetScroll = index * (containerHeight * 0.7);
    container.scrollTo({
      top: targetScroll,
      behavior: 'smooth'
    });
    this.activeCardIndex = index;
    this.updateActiveCardStyles();
  }

  protected readonly ServicesArray = ServicesArray;
}
